import React from 'react';
import { Col, Row } from 'react-bootstrap';

import ReadMore from '../../components/ReadMore';
import leadersForStandardsAndSolutions from '../../../assets/images/leadersForStandardsAndSolutions.jpeg';

const LeadersForStandards = ({ isMobile }) => {

  return (
    <Col>
      <Row>
        <Col>
          {/* @ADVISE - This is an h2 but feels like it should be an h3... */}
          <h2
            id="leaders-for-standards-and-solutions"
            tabIndex="-1"
          >
            LEADERS FOR STANDARDS & SOLUTIONS
          </h2>
        </Col>
      </Row>
      <Row style={{ marginTop: 30 }}>
        <Col xs={12} md={6} lg={8}>
          <p>
            CSIO members look to us first for Data Standards and technology solutions. We continue
            to lead the evolution of Standards and solutions by bringing the Canadian Property and
            Casualty (P&C) industry together for consensus on the language and data we’re all going
            to use.
          </p>
          <p>
            In 2021, we reached important milestones in eliminating a slow and unwieldy process
            for answering customers’ billing and claims questions by leveraging established industry
            infrastructure.
          </p>
          <p>
            We continued to help set brokers up for commercial client success, adding Data Standards
            for a new sector: multi-operations small business.
          </p>
          <p>
            We’re proud to bring Members, Committees and Working Groups together to ease these
            and other pain points that are barriers to business.
          </p>
        </Col>
        <Col xs={12} md={6} lg={4} style={{
          paddingTop: 20,
          paddingBottom: 20,
          paddingLeft: 40
        }}>
          <div style={{
            backgroundImage: `url(${leadersForStandardsAndSolutions})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            width: '100%',
            height: '100%'
          }} />
          </Col>
      </Row>
      <Row style={{ marginTop: 20 }}>
        <Col>
          <ReadMore href="/leaders-for-standards-and-solutions#top" />
        </Col>
      </Row>
    </Col>
  )
}

export default LeadersForStandards;
